module.exports = __webpack_public_path__ + "static/media/shiftshave-logo.9009e72c.png";